var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "login-mode": _vm.layout === "PORCH",
        dense: _vm.denseMode,
        "layout-public": _vm.layout === "PUBLIC",
      },
      style: { "background-image": _vm.backgroundImage },
      attrs: { id: "app" },
    },
    [
      _vm.browserNotCompatible
        ? _c("div", { staticClass: "not-compatible-browser" }, [
            _c("i", {
              staticClass: "fa fa-times",
              on: { click: _vm.hideBrowserMessage },
            }),
            _vm._v(" "),
            _c("i", { staticClass: "fa fa-frown-o" }),
            _c("span", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("global.notCompatibleBrowser")),
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("Loading", { ref: "loading" }),
      _vm._v(" "),
      _c("Confirm", { ref: "confirm" }),
      _vm._v(" "),
      _vm.blocker ? _c("Blocker") : _vm._e(),
      _vm._v(" "),
      _c("Messages", { ref: "messages" }),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "modal",
          attrs: {
            width: _vm.modalProps.width,
            height: _vm.modalProps.height,
            type: _vm.modalPropsType,
            resetContent: _vm.modalProps.resetContent || false,
          },
        },
        [
          _c("span", {
            attrs: { slot: "header" },
            domProps: { innerHTML: _vm._s(_vm.modalProps.title) },
            slot: "header",
          }),
          _vm._v(" "),
          _c(_vm.modalComponent, {
            tag: "component",
            attrs: { slot: "content", props: _vm.modalComponentProps },
            slot: "content",
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.layout === "DEFAULT"
        ? _c("UiNavbar", { class: { blur: _vm.blur }, attrs: { acl: _vm.acl } })
        : _vm._e(),
      _vm._v(" "),
      _vm.layout === "DEFAULT" && _vm.alertsToShow.length !== 0
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-browse-alerts",
                  expression: "'beepiz-browse-alerts'",
                },
              ],
              staticClass: "alerts-container",
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                },
                [
                  _vm.alertsToShow.length > 6 && !_vm.alertHideAll
                    ? _c(
                        "b-button",
                        {
                          staticStyle: { "margin-right": "219px" },
                          attrs: { pill: "", variant: "danger" },
                        },
                        [
                          _vm._v(
                            "+" +
                              _vm._s(_vm.alertsToShow.length - 6) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.alertsToShow.length > 0 && _vm.alertHideAll === false
                    ? _c(
                        "b-button",
                        {
                          staticStyle: { "margin-left": "7px" },
                          attrs: { pill: "", variant: "dark" },
                          on: {
                            click: function ($event) {
                              _vm.alertHideAll = true
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-chevron-down",
                            staticStyle: { "font-size": "10px" },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.alertsToShow.length > 0 && _vm.alertHideAll === true
                    ? _c(
                        "b-button",
                        {
                          staticStyle: { height: "50px", width: "50px" },
                          attrs: { pill: "", variant: "danger" },
                          on: {
                            click: function ($event) {
                              _vm.alertHideAll = false
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-bell",
                            staticStyle: { "font-size": "16px" },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.alertList.length !== 0 && !_vm.alertHideAll
                ? _c(
                    "div",
                    _vm._l(_vm.alertList, function (alert) {
                      return _c("Alert", {
                        key: alert.id,
                        attrs: { alert: alert },
                        on: {
                          dismiss: _vm.handleDismiss,
                          maximize: _vm.handleMaximize,
                          hide: _vm.handleHide,
                        },
                      })
                    }),
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.layout !== "PUBLIC"
        ? _c(
            "section",
            {
              staticClass: "main-container bg-gray-50",
              class: { blur: _vm.blur },
            },
            [_c("router-view", { key: _vm.$route.fullPath })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.layout === "PORCH"
        ? [
            _vm.isThemeSfr
              ? _c("div", { staticClass: "footer" }, [
                  _vm._v("\n      © 2025 SFR DATI - "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://sfr.beepiz.com/",
                        target: "_blank",
                      },
                    },
                    [_vm._v("www.sfr.beepiz.com")]
                  ),
                ])
              : _vm.isThemeCatsafe
              ? _c("div", { staticClass: "footer" }, [
                  _vm._v("\n      © 2025 CAT'SAFE - "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://catsafe.beepiz.com/",
                        target: "_blank",
                      },
                    },
                    [_vm._v("www.catsafe.beepiz.com")]
                  ),
                ])
              : _c("div", { staticClass: "footer" }, [
                  _vm._v("\n      © 2025 BEEPIZ - "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.beepiz.com",
                        target: "_blank",
                      },
                    },
                    [_vm._v("www.beepiz.com")]
                  ),
                ]),
            _vm._v(" "),
            _c("div", { ref: "httpcsBadge", staticClass: "httpcs-badge" }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.layout === "PUBLIC"
        ? [_c("router-view", { key: _vm.$route.fullPath })]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }